import React, { useState } from "react";
import MainLayout from "../components/layout/MainLayout";
import CountryList from "../features/countries/CountryList";
import CountryForm from "../features/countries/CountryForm";
import { useNotification } from "../context/NotificationContext";
import countryService from "../services/countryService";

const Countries = () => {
  const [showForm, setShowForm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const { showSuccess } = useNotification();

  const handleCreate = () => {
    setShowForm(true);
  };

  const handleFormSubmit = async (formData) => {
    try {
      setLoading(true);
      const response = await countryService.createCountry(formData);
      if (response.success) {
        showSuccess("Country created successfully!");
        setShowForm(false);
        setRefreshTrigger((prev) => prev + 1);
      }
    } catch (error) {
      console.error("Form submission error:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleFormCancel = () => {
    setShowForm(false);
  };

  return (
    <MainLayout>
      <div className="countries-page">
        {/* Page Header */}
        <div className="d-flex justify-content-between align-items-center mb-4">
          <div>
            <h1 className="h3 mb-1 fw-bold text-dark">Country Management</h1>
            <p className="text-muted mb-0">
              Manage countries for location data
            </p>
          </div>
          <button className="btn btn-primary" onClick={handleCreate}>
            <i className="fas fa-plus me-2"></i>
            Add Country
          </button>
        </div>

        {/* Form Modal */}
        {showForm && (
          <div
            className="modal show d-block"
            style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">
                    <i className="fas fa-globe me-2"></i>
                    Add New Country
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={handleFormCancel}
                    disabled={loading}
                  ></button>
                </div>
                <div className="modal-body">
                  <CountryForm
                    onSubmit={handleFormSubmit}
                    onCancel={handleFormCancel}
                    loading={loading}
                  />
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Countries List */}
        <CountryList refreshTrigger={refreshTrigger} />
      </div>
    </MainLayout>
  );
};

export default Countries;
